:host {
  --header-height: 56px;
  --header-host-height: 56px;

  @include media-min(md) {
    --header-height: 80px;
    --header-host-height: 80px;
  }

  @include media-min(xl) {
    --header-host-height: 128px;
  }

  --header-max-width: 1920px;

  @include media-max('xxl', false) {
    --header-max-width: 1440px;
  }

  display: flex;
  justify-content: center;
  height: var(--header-host-height);
}

.header-wrapper {
  display: grid;
  grid-auto-flow: row;
  margin: 0 auto;
  background-color: $color-white;
  box-shadow: 0px 16px 24px -4px rgba($color-dark-blue-02, 0.12);

  max-width: min(100vw, var(--header-max-width));
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;

  &.header--hidden {
    transform: translateY(-100%);
  }

  .header-main-nav-wrapper {
    height: 0;
    max-width: min(100vw, var(--header-max-width));

    @include media-min(xl) {
      height: auto;
    }
  }
}
